export default {
      id: "list-usage",
      viewBox: "0 0 24 18",
      url: __webpack_public_path__ + "img/icons.df848786.svg#list",
      toString: function () {
        return this.url;
      }
    }